// Shared per-slug cache + in-flight de-dupe for `GET /page-composition/:slug`.
// Three different surfaces probe/consume this endpoint for the same slug
// in quick succession — CustomStaticPage and CmsPageOverride both call it
// just to check "is this a modular page?", then hand off to <ModularPage>
// which fetches the exact same URL again to actually render it. Routing
// all three through one cache means that's one network call, not two or
// three, and a revisit within the TTL renders instantly with no spinner.
import axios from "axios";
import { getApiUrl } from "@/utils/api";

const API = getApiUrl();
const TTL_MS = 20_000;
const _cache = {};

export const getCachedPageComposition = (slug) => {
  const entry = _cache[slug];
  return entry && entry.value !== undefined ? entry.value : null;
};

export const isPageCompositionFresh = (slug) => {
  const entry = _cache[slug];
  return !!entry && entry.value !== undefined && Date.now() - entry.ts < TTL_MS;
};

export const fetchPageComposition = (slug, { force = false } = {}) => {
  const entry = _cache[slug];
  if (!force) {
    if (entry?.promise) return entry.promise;
    if (entry && entry.value !== undefined && Date.now() - entry.ts < TTL_MS) {
      return Promise.resolve(entry.value);
    }
  }
  const promise = axios.get(`${API}/page-composition/${slug}`).then((res) => {
    _cache[slug] = { value: res.data, ts: Date.now() };
    return res.data;
  }).catch((err) => {
    delete _cache[slug];
    throw err;
  });
  _cache[slug] = { ..._cache[slug], promise };
  return promise;
};
